export const hexToRgb = (hex: string, alpha: number = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getLabelColor = (color?: 'violet' | 'red') => {
  switch (color) {
    case 'violet':
      return '#1624C2';
    case 'red':
      return '#CE4622';
    default:
      return '#65ADFF';
  }
};
